<template>
  <OrderTestDialog 
    :title="updateAddressTitle" 
    :width="546" 
    :is-show-dialog="isShowDialog"
    :show-footer="false"
    @close="$emit('close')"
  >
    <div v-if="!swapflag">
      <div class="address-div">
        <p >Patient Current Address</p>
        <p class="shipping-address">{{ displayCurrentAddress }}</p>
      </div>
      <div >
        <p class="subtitle-text">Do you want to update it to the family shipping address?</p>
      </div>
      <div class="address-div" style="background: rgba(232, 244, 253, 0.50);">
        <p>Shipping Address</p>
        <p class="shipping-address" style="color: #20A7C1;">{{ shippingAddress }}</p>
      </div>
      <div>
        <Alert class="my-5">
          <p class="warning-text">
            If updated, the address for {{ patient.name }} will be replaced.
          </p>
        </Alert>
      </div>
      <div class="footer-div">
        <LoginButton @click="$emit('openSearchPatientDialog')">
          Back
        </LoginButton>
        <div class="flex items-center">
          <LoginButton type="primary" plain class="w-36 mr-3" @click="keepOriginal">
            Keep Original
          </LoginButton>
          <LoginButton type="primary" plain class="w-36" @click="handleUpdateAddress" :loading="updateAddressLoading">
            Update Address
          </LoginButton>
        </div>
      </div>

    </div>
    <div v-else>
      <p class="subtitle-text confirm">This patient's address has been updated.</p>
      <div class="pt-4 flex justify-center">
        <LoginButton type="primary" class="w-18" @click="$emit('openChooseFamilyMemberDialog')">
          Ok.
        </LoginButton>
      </div>
    </div>
  </OrderTestDialog>
</template>

<script>
import OrderTestDialog from "@/views/va-orderTest/components/OrderTestDialog.vue";
import LoginButton from "@/views/login/components/LoginButton.vue";
import Alert from "@/NewLibrary/Alert.vue";
import { mapState } from "vuex";
import { updatePatientApi } from "@/api/va-order-page/orderTest";

export default {
  emits: ['close','openUpdateAddressDialog', 'openChooseFamilyMemberDialog', 'openSearchPatientDialog'],
  components: {
    OrderTestDialog,
    LoginButton,
    Alert,
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    shippingAddress: {
      type: String,
      default: ""
    },
    patient: {
      type: Object,
      default: () => ({
        id: null,
        name: "",
        currentAddress: "",
      })
    },
    shippingAddressObj: {
      type: Object,
      default: () => ({
        streetAddress: "",
        city: "",
        state: "",
        zipcode: "",
        country: ""
      })
    }
  },
  computed: {
    ...mapState("orderTest/familyDiscount", ["familyMembers"]),

    displayCurrentAddress() {
      return this.patient.currentAddress ? this.patient.currentAddress : "N/A";
    }
  },
  data() {
    return {
      updateAddressTitle: "Update Address",
      swapflag: false, 
      updateAddressLoading: false,
    }
  },
  methods: {
    async handleUpdateAddress() {
      // update address
      try {
        this.updateAddressLoading = true;
        let { streetAddress, city, state, zipcode, country } = this.shippingAddressObj;
        let payload = {
          patient_id: this.patient.id,
          patient_name: this.patient.name,
          patient_street_address: streetAddress,
          patient_city: city,
          patient_state: state,
          patient_zipcode: zipcode,
          patient_country: country ? country : null,
        };
        let { data } = await updatePatientApi(payload);
        this.addFamilyMember(this.patient);
        this.updateAddressLoading = false;
        this.updateAddressTitle = "Success!"
        this.swapflag = true;
      } catch (error) {
        this.updateAddressLoading = false;
        console.log("family bundle update address error", error);
      }
      
    },
    keepOriginal() {
      this.addFamilyMember(this.patient);
      this.$emit('openChooseFamilyMemberDialog');
    },
    addFamilyMember(patientObj) {
      let { id, name, birthDate, gender } = patientObj;
      let familyMember = {
        id,
        name,
        birthDate,
        gender,
        isSelected: true,
      };
      this.$store.dispatch("orderTest/familyDiscount/addFamilyMember", familyMember);
    }
  }
}
</script>

<style scoped>
.address-div{
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FDF0E380;
  padding: 10px 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  border-radius: 5px;
}
.shipping-address {
  margin-top: 12px;
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  color: #666666;

}
.subtitle-text {
  color:#161616;
  font-size: 16px;
  font-weight: 500;
  margin-top: 20px;
  margin-bottom: 20px;
}
.subtitle-text .confirm{
  margin: 0;
}
.footer-div {
  display: flex;
  justify-content: space-between;
  padding-top: 12px;
}

.warning-text {
  color: #333333;
  font-family: "IBM Plex Sans Hebrew";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
}
</style>
